// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"4c94a53d","440":"620567cc","812":"f9123298"}[chunkId] + ".chunk.js";
};